export const GL_NEAREST = 0x2600;
export const GL_LINEAR	= 0x2601;
export const GL_NEAREST_MIPMAP_NEAREST	= 0x2700;
export const GL_LINEAR_MIPMAP_NEAREST	= 0x2701;
export const GL_NEAREST_MIPMAP_LINEAR	= 0x2702;
export const GL_LINEAR_MIPMAP_LINEAR	= 0x2703;
